/** Mantle Staking — `mETHToETH(uint256)` quotes mETH → ETH at the
 *  current rate. Call with `10**18` to get the 1e18-scaled rate. */
export const MantleStakingAbi = [
  {
    name: 'mETHToETH',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'mETHAmount' }],
    outputs: [{ type: 'uint256' }],
  },
] as const
